import React, { useState } from 'react';
import { PrimaryButton, SecondaryButton, SizeableRoundedDialog, UnderlineTextInput, Text, Colors } from 'library';
import { Grid, InputAdornment } from '@mui/material';
import { client } from 'shared';

export default function EditPayModal({
    open,
    onClose,
    initialPay,
    jobId,
    workerUserId,
    refresh,
}: {
    open: boolean;
    onClose: () => void;
    initialPay: number;
    jobId: number;
    workerUserId: number;
    refresh: () => void;
}) {
    const [pay, setPay] = useState(initialPay.toString());
    const errorMessage =
        Number(pay) >= initialPay
            ? ''
            : 'You cannot decrease the pay rate after a shift is booked. Please contact Tandem for assistance.';

    function handleSave() {
        client(`api/business-job/${jobId}/update-pay`, {
            method: 'POST',
            body: {
                pay,
                worker_user: workerUserId,
            },
        }).then(() => {
            onClose();
            refresh();
        });
    }

    return (
        <SizeableRoundedDialog
            open={open}
            onClose={onClose}
            contentStyle={{ padding: 10 }}
            style={{ padding: 30, maxWidth: 400 }}
        >
            <Text variant="h2" bold textStyle={{ marginBottom: 20 }}>
                Edit Pay Rate
            </Text>
            <Text variant="body2" textStyle={{ marginBottom: 20 }}>
                The pay rate for all unpaid shifts for this teacher and job will be updated to the amount you enter. You
                can only increase pay after a shift is booked. If you need help with a past shift or other change,
                please contact us through the chat or by emailing us at team@join-tandem.com.
            </Text>
            <UnderlineTextInput
                type="number"
                style={{ marginBottom: 20 }}
                InputProps={{ startAdornment: <InputAdornment position="start">$</InputAdornment> }}
                inputProps={{ min: initialPay }}
                value={pay}
                onChange={(e) => setPay(e.target.value)}
            />
            <Grid container direction="row" justifyContent="flex-end" gap={2}>
                <SecondaryButton onClick={onClose} buttonStyle={{ width: 'auto' }}>
                    Cancel
                </SecondaryButton>
                <PrimaryButton disabled={!!errorMessage} onClick={handleSave} buttonStyle={{ width: 'auto' }}>
                    Save
                </PrimaryButton>
            </Grid>
            {errorMessage && (
                <Text variant="body2" textStyle={{ marginTop: 10 }} color={Colors.mediumRed}>
                    {errorMessage}
                </Text>
            )}
        </SizeableRoundedDialog>
    );
}
